export const MIN_WIDTH_DISPLAY_ARCHIVE = 635;
export const MIN_WIDTH_DISPLAY_COPE_CARD = 470;
export const MIN_WIDTH_DISPLAY_MOVE_TO = 470;
export const MIN_WIDTH_DISPLAY_SET_IN_WORK = 635;
export const CLASS_NAME_BUTTON_HIDE_TITLE = 'head-actions__button-hide-title';
